module.exports = __webpack_public_path__ + "assets/images/green-xmas-9.jpg?v=8b978280";